export default {
    common: {
        datepicker: {
            months: {
                july: 'July',
                september: 'September',
                april: 'April',
                march: 'March',
                may: 'May',
                february: 'February',
                june: 'June',
                january: 'January',
                november: 'November',
                october: 'October',
                august: 'August',
                december: 'December',
            },
            days: {
                tuesday: 'Tues.',
                thursday: 'Thur.',
                saturday: 'Sat.',
                wednesday: 'Wed.',
                monday: 'Mon.',
                friday: 'Fri.',
                sunday: 'Sun.',
            },
        },
        label: {
            insured: 'Insured',
            selected: 'Selected',
            noValue: 'No value',
            cancel: 'Cancel',
            bestseller: 'Bestseller',
            moreDetails: 'Details',
            next: 'Next',
            no: 'No',
            ok: 'OK',
            choose: 'Select',
            to: 'to',
            notInsured: 'Not insured',
            back: 'Back',
            save: 'Save',
            edit: 'Edit',
            yes: 'Yes',
        },
        unsavedData: {
            message: 'You have unsaved data on this page. Do you really want to reload the page?',
        },
        technicalError: {
            actionText: 'Try again',
            message: 'Due to a technical error, your request could not be processed. Please try again later.',
        },
        invalidForm: {
            message: 'Unfortunately, the details you entered are either incomplete or invalid. Please check your details and try again.',
        },
    },
    summaryStep: {
        insurance: {
            title: 'Insurance cover selected',
            subtitle: 'Benefits included (you can find details and explanations in the schedule of benefits)',
        },
        share: {
            label: 'Forward by email',
            heading: 'Forward, edit later or print',
            send: {
                label: 'Send',
            },
            subtitle: 'You can send this summary by email.<br>Your details will be saved and can be added to or amended later.<br>You can also print out this summary.',
            toast: {
                success: 'An email with the link has been sent.',
                failed: 'Unfortunately, the email could not be sent.',
            },
        },
        contact: {
            phone: {
                label: 'Telephone number',
            },
            mail: {
                label: 'Confirmation email address',
            },
            title: 'Contact details of the policyholder',
        },
        construction: {
            title: 'Construction project',
            sum: {
                label: 'Sum',
            },
            duration: {
                label: 'Construction period',
            },
        },
        title: 'Summary',
        advisor: {
            title: 'Intermediary’s details',
            mail: {
                label: 'Intermediary’s email address',
            },
        },
        risks: {
            title: 'Features',
        },
        print: {
            title: 'Construction insurance',
            label: 'Print summary',
        },
        submit: {
            hint: 'Your insurance cover will start from the date entered online as the start of construction.',
            label: 'Purchase now',
        },
        edit: {
            toast: {
                message: 'Your premium has been recalculated.',
            },
        },
        avb: {
            label: 'I confirm that I have read the <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/factsheets/Factsheet_Bauversicherung.pdf" target="_blank">Product Information</a> and agree to the <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/vertragsbedingungen/Vertragsbedingungen_Bauversicherung.pdf" target="_blank">General Terms and Conditions</a>.<br>I confirm that I have read and agree to the <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/service/Datenschutz.pdf" target="_blank">privacy policy</a>.<br>',
        },
        dp: {
            text: 'By transmitting your data, you consent to our processing your request. You have the right to revoke your consent at any time. Further information on how we process data can be found in our <a href="https://www.baloise.ch/en/about-us/information/privacy-policy.html" target="_blank">privacy policy</a> .',
        },
    },
    matrixStep: {
        liability: {
            visitor: {
                label: 'Visitor accident',
            },
            personAndPropertyDamage: {
                label: 'Maximum indemnity (one-time guarantee for the whole term of the contract)',
            },
            label: 'Principal’s liability',
            doubleGuaranty: {
                label: 'Twofold guarantee (the insured amount is available twice)',
            },
            legalProtectionAndFinancialLosses: {
                label: 'For pure financial loss and for legal protection in criminal proceedings',
            },
        },
        construction: {
            earthquake: {
                label: 'Earthquakes and volcanic eruptions',
            },
            base: {
                tooltip: 'Basic cover includes unforeseen property damage during the construction period to the building under construction before it has been completed. Theft of assembled or installed items is also covered.',
                label: 'Basic cover',
            },
            addition: {
                one: {
                    label: 'For moved objects, for expert and damage search costs, for building water damage',
                },
                label: 'Supplementary cover',
                two: {
                    label: 'For scratches on glazing, for additional costs for overtime and air freight, for delays in construction and interruption',
                },
                tooltip: 'Supplementary cover includes, but is not limited to, scaffolding, props and other material, excavation and soil mass, existing structures, chattels, construction equipment, tools, construction machinery and equipment.',
                three: {
                    label: 'Burglary of property not connected to the construction work',
                },
            },
            label: 'Construction',
        },
        quote: {
            label: 'Single premium in CHF',
            stampDuty: {
                label: 'Incl. stamp duty',
            },
        },
        details: {
            link: 'https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/factsheets/Factsheet_Bauversicherung.pdf',
            label: 'This representation is only a summary. You will find the full details and explanations in the <a href="https://www.baloise.ch/dam/baloise-ch/unternehmenskunden/documents/de/factsheets/Factsheet_Bauversicherung.pdf" target="_blank">schedule of benefits</a>.',
        },
        deductible: {
            hint: 'for construction and principal’s liability',
            label: 'Deductible',
        },
        additionalLimit: {
            hint: 'for construction and principal’s liability',
            label: 'Double Guarantee',
            singleGuarantee: '-',
            doubleGuarantee: 'Insured',
        },
        title: 'Select the right insurance cover for you',
    },
    typeStep: {
        constructionType: {
            apartmentHouse: {
                label: 'Multiple-family dwelling',
            },
            altLink: {
                text: 'If you cannot find the type of building you are looking for,',
                alt: 'please click here to continue.',
                url: 'https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html',
            },
            industrialBuilding: {
                label: 'Commercial building',
            },
            commerceAndLiving: {
                label: 'Residential and commercial building',
            },
            detachedHouse: {
                label: 'Single-family dwelling',
            },
            title: 'Please select your type of building',
            validation: {
                message: 'Please select your type of building.',
            },
        },
        constructionKind: {
            renovation: {
                tooltip: 'If a building is to be renovated without changes being made to any load-bearing elements (e.g. demolition of a supporting wall) or work being done to the roof, please select “Renovation”.',
                label: 'Renovation',
            },
            newBuilding: {
                tooltip: 'If a new building is to be constructed or if an existing building is to be extended or converted, please select “New build / extension / conversion”.',
                label: 'New build / extension / conversion',
            },
            title: 'Please select your construction project.',
        },
    },
    riskStep: {
        supportStructureChanged: {
            tooltip: 'If your answer is “No”, we will assume that the construction project is a renovation.',
            label: 'Will any load-bearing elements in the building (e.g. walls, ceilings, balconies) be changed or will work be done to the roof?',
        },
        underpinning: {
            tooltip: 'Underpinning/construction work extending beneath third-party or own building elements / works (e.g. buildings, retaining walls, canals, railway systems)',
            label: 'Will building elements/works be underpinned or will the construction work extend beneath them?',
        },
        groundwater: {
            label: 'Will the groundwater level be lowered?',
            tooltip: 'Lowering of groundwater level within a closed excavation space or outside the excavation (open dewatering does not count as lowering the groundwater level)',
        },
        dangerZone: {
            warning: 'Unfortunately, we are unable to calculate your premium online because your construction project is in a danger zone. However, we would still be happy to make you an offer. Please get in touch with us: <a target="_blank" href="https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html?targetPageName=Bauversicherung-P"> at</a>.',
            label: 'Is the construction project located in a hazard zone with medium or significant risk of flooding, moving ground, landslide, rockfall, avalanche, or is there a risk of surface runoff (water depth ≥25 cm)?',
            tooltip: 'The hazard maps of the cantons, the Principality of Liechtenstein, the Association of Cantonal Insurance Institutions (AICA), and the Swiss Insurance Association (SIA) are decisive for the assessment. If hazards have been assessed differently in the geological survey, these assessments are decisive.',
        },
        ram: {
            label: 'Will piles, sheet piles or steel girders be driven, vibrated or pressed into the ground?',
        },
        rock: {
            label: 'Will any rock be removed?',
        },
        newConstruction: {
            label: 'Will a new building be constructed?',
        },
        title: 'A few questions about your construction project',
    },
    success: {
        title: 'Thank you.',
        lead: 'We have received your details.<br>You will receive your contract documents shortly.<br>If you have any questions, please contact us at <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
    },
    contactStep: {
        birthdate : {
            label: 'Birth Date',
        },
        street: {
            validation: {
                message: 'Please enter a valid street.',
            },
            placeholder: 'Street and house number',
        },
        title: 'Almost done!',
        lastName: {
            placeholder: 'Last name',
            validation: {
                message: 'Please enter a valid last name.',
            },
        },
        languageOfCorrespondence: {
            de: 'German',
            label: 'Language of correspondence',
            fr: 'French',
            it: 'Italian',
        },
        postcode: {
            placeholder: 'Postcode',
            validation: {
                message: 'Please enter a valid postcode.',
            },
        },
        city: {
            validation: {
                message: 'Please enter a valid town/city.',
            },
            placeholder: 'Town/city',
        },
        firstName: {
            placeholder: 'First name',
            validation: {
                message: 'Please enter a valid first name.',
            },
        },
        subtitle: {
            email: 'Who should we send the confirmation to?',
            contact: 'Contact details of the policyholder',
        },
        salutation: {
            validation: {
                message: 'Please select a title.',
            },
            female: 'Ms',
            male: 'Mr',
            company: 'Company',
        },
        phone: {
            validation: {
                message: 'Please enter a valid telephone number.',
            },
            placeholder: 'Telephone number',
        },
        advisor: {
            placeholder: 'If you have been referred, please enter the name and intermediary number of the intermediary (e.g. architect, broker) here.',
            label: 'Intermediary’s details (optional)',
            contactStep: {},
        },
        advisorMail: {
            placeholder: 'Intermediary’s email address (optional)',
        },
        email: {
            placeholder: 'Policyholder’s email address',
            validation: {
                message: 'Please enter a valid email address.',
            },
        },
        companyName: {
            placeholder: 'Company',
            validation: {
                message: 'Please enter a valid company name.',
            },
        },
        next: 'Continue to summary',
    },
    whenStep: {
        startDate: {
            title: 'When will you begin construction?',
            validation: {
                message: 'Please select a valid date.',
            },
            tooltip: 'The insurance cover will begin with the conclusion of the contract at the earliest.',
            placeholder: 'Start of construction',
        },
        completionDate: {
            validation: {
                message: 'Please select the period.',
            },
            title: 'Until when do you build?',
            year: 'year',
            placeholder: 'End of construction',
            upTo: 'Up to',
            tooltip: 'If your construction project will take longer than three years, please contact us <a target="_blank" href="https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html?targetPageName=Bauversicherung-P"> at.</a>',
            years: 'years',
        },
        title: 'Construction period',
    },
    whereStep: {
        postcode: {
            placeholder: 'Postcode',
            label: '',
            validation: {
                message: 'Please enter a valid postcode.',
            },
        },
        street: {
            label: '',
            validation: {
                message: 'Please enter a valid address.',
            },
            placeholder: 'Street and house number or plot number',
        },
        city: {
            validation: {
                message: 'Please enter a valid town/city.',
            },
            placeholder: 'Town/city',
            dropDownLabel: 'Please select',
            label: '',
        },
        title: 'Where will you be building?',
    },
    fail: {
        lead: 'Please try again later or contact us at <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        title: 'Unfortunately, an error has occurred.',
    },
    sumStep: {
        sum: {
            info: {
                text1: 'To calculate the construction sum, add up items 1 to 4 on the construction cost plan (incl. value-added tax, fees and the principal’s own contributions).',
                text2: 'Costs for preliminary studies, competitions, land acquisition, development, financing and fees are not included in the construction sum.',
                text3: 'If your construction sum is higher than CHF 10 million, please contact us , <a target="_blank" href="https://www.baloise.ch/de/unternehmenskunden/versichern/haftpflicht-recht-sachwerte/bau/bauversicherung/offerteanfrage-bauversicherungen-1.html?targetPageName=Bauversicherung-P"> at.</a>',
                title: 'How do I calculate the construction sum?',
            },
            label: 'CHF',
            placeholder: '500,000',
            validation: {
                message: 'The construction sum must be at least CHF 10,000 and cannot exceed CHF 10 million.',
            },
        },
        title: 'What is the construction sum?',
    },
    app: {
        title: 'Baloise Construction Insurance',
    },
    overview: {
        print: {
            label: 'Print offer',
        },
        hint: {
            text: 'If you have any questions, please contact us at <a target="_blank" href="mailto:easyconstruct@baloise.ch">easyconstruct@baloise.ch</a>.',
        },
        title: 'All the details of your offer',
    },
    easteregg: {
        message: 'Brought to you with a smile by the Bets team',
    },
};
